import type { Test } from "../../api/tests";

// Slice 3: the engineer's create-time tyre choice rides on the opaque
// kpi_targets bag as `tire_override = { type }`. This pure accessor reads it
// back (null when absent or malformed) for the read-only ③ rail card.
export type TireOverride = { type: string };

export function tireOverrideOf(test: Test): TireOverride | null {
  const raw = (test.kpi_targets as Record<string, unknown> | undefined)?.tire_override;
  if (raw && typeof raw === "object" && typeof (raw as { type?: unknown }).type === "string") {
    return { type: (raw as { type: string }).type };
  }
  return null;
}
